import { composeRenderProps } from 'react-aria-components';
import { twMerge } from 'tailwind-merge';

/** Shared focus ring: visible only for keyboard focus (WCAG 2.2 AA). */
export const focusRing =
  'outline-none data-[focus-visible]:outline-2 data-[focus-visible]:outline-offset-2 data-[focus-visible]:outline-border-focus';

/** Merge a component's own classes with a consumer's className (string or React Aria render function). */
export function composeTwRenderProps<T>(
  className: string | ((v: T) => string) | undefined,
  base: string,
): string | ((v: T) => string) {
  return composeRenderProps(className, (cn) => twMerge(base, cn));
}
